import { action, runInAction, observable } from 'mobx';
// import cloneDeep from 'lodash/cloneDeep';
import { ErrorInterface } from 'modules/core/api/globalApi';
import cloneDeep from 'lodash/cloneDeep';
import promoController from './controller';
import { ClientPromoInterface, CreateClientPromoRequest, UpdateClientPromoRequest } from '../api/promoApi';

export interface PromoStore {
  clientPromos: ClientPromoInterface[],
  getClientPromosByClientId: string,
  currentClientPromo: ClientPromoInterface,

  error: ErrorInterface,
}

const initialValues: PromoStore = {
  clientPromos: [],
  getClientPromosByClientId: null,
  currentClientPromo: null,

  error: null,
};

export const promoStore = observable(initialValues);

export const promoActions = {

  async getClientPromoList(clientId :string) {
    promoActions.clearError();
    runInAction(() => {
      promoStore.getClientPromosByClientId = clientId;
    });
    const response = await promoController.getClientPromoList(clientId);
    if (response.errorData) {
      promoActions.clearClientPromos();
    }
    promoActions.handleError(response);
    runInAction(() => {
      promoStore.clientPromos = response.data?.items;
    });
  },

  handleError: action((response, id:string = null) => {
    if (response.errorData) {
      const { errorData } = response;
      promoStore.error = {
        message: errorData?.message,
        errorCode: errorData?.errorCode,
        timestamp: errorData?.timestamp,
        status: response?.status,
        connectError: response?.connectError,
        isError: response?.error,
        id,
      };
      // schedulerReferenceStore.loading = false;
      throw errorData;
    }
  }),

  handleErrorWithoutThrow: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      // schedulerReferenceStore.loading = false;
      promoStore.error = errorData;
    }
  }),

  createClientPromo: async (request: CreateClientPromoRequest): Promise<void> => {
    promoActions.clearError();
    const response = await promoController.createClientPromo(request);
    promoActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        promoStore.clientPromos.push(response.data);
      }
    });
  },

  updateClientPromo: async (id: string, request: UpdateClientPromoRequest): Promise<void> => {
    promoActions.clearError();
    const response = await promoController.updateClientPromo(id, request);
    promoActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        promoStore.clientPromos = promoStore.clientPromos
          .map((v) => (v.id === response.data.id
            ? { ...response.data }
            : { ...v }));
      }
    });
  },

  deleteClientPromo: async (id: string): Promise<void> => {
    promoActions.clearError();
    const response = await promoController.deleteClientPromo(id);
    promoActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        promoStore.clientPromos
          .find((v) => v.id === id).deletedDate = 'deleted';
      }
    });
  },

  restoreClientPromo: async (id: string): Promise<void> => {
    promoActions.clearError();
    const response = await promoController.restoreClientPromo(id);
    promoActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        promoStore.clientPromos = promoStore.clientPromos
          .map((v) => (v.id === response.data.id
            ? { ...response.data }
            : { ...v }));
      }
    });
  },

  clearClientPromos: async () => {
    try {
      runInAction(() => {
        promoStore.clientPromos = [];
        promoStore.getClientPromosByClientId = null;
      });
    } catch (err) {
      promoActions.handleError(err);
    }
  },

  setCurrentClientPromo: async (data: ClientPromoInterface): Promise<void> => {
    promoActions.clearError();
    runInAction(() => {
      const x = cloneDeep(data);
      x.promoId = data?.promo?.id;
      promoStore.currentClientPromo = x;
    });
  },

  clearCurrentPromo: async (): Promise<void> => {
    promoActions.clearError();
    runInAction(() => {
      promoStore.currentClientPromo = null;
    });
  },

  clearError: action(() => {
    promoStore.error = null;
  }),

};
